module.exports = __webpack_public_path__ + "img/1.95a18545.jpg";